

export default function defaultFetchRetry(fetch, url, options, retryOptions) {

  const defaultConfiguration = {
    retries: 15,
    retryDelay: 4000
  };

  const { retries, retryDelay } = Object.assign({}, defaultConfiguration, retryOptions);

  let retry = (wrappedFetch, retryCounter, resolve, response) => {
    if (retryCounter > 0) {
      setTimeout(() => wrappedFetch(--retryCounter), retryDelay);
    } else {
      response.retryTimeout = true;
      resolve(response);
    }
  };

  return new Promise(resolve => {
    let wrappedFetch = (retryCounter) => {
      fetch(url, options)
        .then((response) => {
          if (response.status === 404) {
            retry(wrappedFetch, retryCounter, resolve, response);
          } else {
            resolve(response);
          }
        })
        .catch((error) => {
          retry(wrappedFetch, retryCounter, resolve, error);
        });
    };

    wrappedFetch(retries);
  });
};
